module.exports = __webpack_public_path__ + "img/no-q_no-pharma-logo.828e7a4a.svg";